<template>
  <fragment>
    <hero-header hero-title="mainNavBar.faq" page-name="infoPopup.hashTags"></hero-header>
    <v-container class="my-10">
      <v-expansion-panels multiple>
        <v-expansion-panel v-for="item in 11" :key="item">
          <v-expansion-panel-header expand-icon="mdi-chevron-down">
            <div class="title font-weight-bold py-4">
              {{ item }}. {{ $t(`faq.faq${item}.q`) }}
            </div>
          </v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <div class="py-4" v-html="$t(`faq.faq${item}.a`)"></div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from "../components/heroHeader.vue";

export default {
  name: 'FAQPage',
  components: {
    heroHeader,
  },
  props: {
    //
  },
  data() {
    return {

    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
